var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { updateLongReadPost } from '../../../../actions/updateLongReadPost';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import { MEDIA_QUERY, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import { SelectorClose } from './selecter';
import { setEditLongRead } from '../../../../actions/setEditLongRead';
import useLocalization from '../../../../hooks/useLocalization';
import CloseIcon from '../../../icons/CloseIcon';
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import useCommonProps from "../../../../hooks/useCommonProps";
import { MobileEditorActions } from '../../../../constants/mobileEditorActions';
import { useGeneralProps } from '../../../../hooks/useGeneralProps';
var Backdrop = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: none;\n  z-index: 1000001;\n  @media (max-width: ", "px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: none;\n  z-index: 1000001;\n  @media (max-width: ", "px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n"])), MEDIA_QUERY_MOBILE);
var Wrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  background: #ffffff;\n  touch-action: none;\n  height: calc(100% - 40px);\n  border-radius: 8px 8px 0 0;\n"], ["\n  position: relative;\n  width: 100%;\n  background: #ffffff;\n  touch-action: none;\n  height: calc(100% - 40px);\n  border-radius: 8px 8px 0 0;\n"])));
var Header = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  //styleName: 320px/Small Text (Reg);\n  font-family: Inter;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #70706f;\n  background: #ffffff;\n  padding: 12px 10px;\n  padding-top: 6px;\n"], ["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  //styleName: 320px/Small Text (Reg);\n  font-family: Inter;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #70706f;\n  background: #ffffff;\n  padding: 12px 10px;\n  padding-top: 6px;\n"])));
var HeaderItem = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var AreaWrap = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 12px;\n  padding-left: 10px;\n  padding-right: 10px;\n\n  textarea,\n  input {\n    resize: none;\n    font-style: normal;\n    font-weight: ", ";;\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: -0.44px;\n    color: #151514;\n    border: none;\n    height: calc(100vh - 64px);\n    width: 100%;\n    outline: none;\n    padding-bottom: 80px;\n  }\n\n  > textarea {\n    overflow-y: auto !important;\n  }\n"], ["\n  margin-top: 12px;\n  padding-left: 10px;\n  padding-right: 10px;\n\n  textarea,\n  input {\n    resize: none;\n    font-style: normal;\n    font-weight: ", ";;\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: -0.44px;\n    color: #151514;\n    border: none;\n    height: calc(100vh - 64px);\n    width: 100%;\n    outline: none;\n    padding-bottom: 80px;\n  }\n\n  > textarea {\n    overflow-y: auto !important;\n  }\n"])), function (p) { return p.bigTypeText ? "700" : "400"; }, function (p) { return p.bigTypeText ? "22px" : "15px"; }, function (p) { return p.bigTypeText ? "28px" : "20px"; });
var Footer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  //todo: \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u0435\u0440\u0435\u043A\u0440\u044B\u0442\u0438\u0435 \u043A\u043D\u043E\u043F\u043A\u0438 \u043F\u0430\u0431\u043B\u0438\u0448\n  height: 100px;\n  border-radius: 8px 8px 0 0;\n  bottom: 0;\n  background: #ffffff;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding-left: 13px;\n  padding-right: 13px;\n  padding-top: 14px;\n  width: 100%;\n"], ["\n  position: absolute;\n  //todo: \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u0435\u0440\u0435\u043A\u0440\u044B\u0442\u0438\u0435 \u043A\u043D\u043E\u043F\u043A\u0438 \u043F\u0430\u0431\u043B\u0438\u0448\n  height: 100px;\n  border-radius: 8px 8px 0 0;\n  bottom: 0;\n  background: #ffffff;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding-left: 13px;\n  padding-right: 13px;\n  padding-top: 14px;\n  width: 100%;\n"])));
var FooterItem = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-family: 'Inter', sans-serif;\n  font-size: 17px;\n  line-height: 22px;\n  font-weight: 700;\n  color: #b1b4ae;\n"], ["\n  font-family: 'Inter', sans-serif;\n  font-size: 17px;\n  line-height: 22px;\n  font-weight: 700;\n  color: #b1b4ae;\n"])));
var SaveButton = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n  border: 1px solid #151514;\n  border-radius: 3px;\n  padding: 4px 16px;\n  color: #151514;\n"], ["\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n  border: 1px solid #151514;\n  border-radius: 3px;\n  padding: 4px 16px;\n  color: #151514;\n"])));
function BottomTextEditor(props) {
    var toggleSubmenu = props.toggleSubmenu, submenu = props.submenu, lgid = props.lgid, isUpdate = props.isUpdate, post = props.post, lang = props.lang, mobileEditorAction = props.mobileEditorAction, toggleMobileEditor = props.toggleMobileEditor, onSetMobTextLength = props.onSetMobTextLength;
    var _a = useState(false), toggle = _a[0], setToggle = _a[1];
    var _b = useState(isUpdate ? post.text : ''), textvalue = _b[0], setTextValue = _b[1];
    var _c = useState(false), isSaveButtonPushed = _c[0], setIsSaveButtonPushed = _c[1];
    var dispatch = useDispatch();
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, lgid); });
    var blocks = currentStore.blocks;
    var userid = localStorage.getItem('userId');
    var t = useLocalization().t;
    var sign = useCommonProps().sign;
    var generalProps = useGeneralProps();
    var menuRef = useRef(null);
    useEffect(function () {
        document.body.style.overflowY = 'hidden';
        document.body.style.touchAction = 'none';
        return function () {
            document.body.style.overflowY = '';
            document.body.style.touchAction = 'auto';
        };
    }, [post]);
    useEffect(function () {
        var _a;
        onSetMobTextLength(((_a = post === null || post === void 0 ? void 0 : post.text) === null || _a === void 0 ? void 0 : _a.length) || 0);
    }, []);
    var savePost = function () {
        // if (isSaveButtonPushed) {
        //   return false;
        // }
        if (isUpdate) {
            var newPost = __assign({}, post);
            newPost.text = textvalue;
            setTimeout(function () { return dispatch(getLongReadPosts(userid, lgid, sign)); }, 1000);
            dispatch(updateLongReadPost('', newPost));
            dispatch(toggleLongReadPostUpdate(0, false, lgid));
            //  в целом не зависит от запроса, можно не дожидаться
            // toggleSubmenu("");
        }
        else {
            dispatch(addLongReadPost({
                id: userid,
                title: '',
                text: textvalue,
                color: 'white',
                imageid: '',
                lgid: lgid,
                isFL: false,
                imgCaption: '',
                style: 'normal',
                num: blocks.length,
                imageData: '',
                generalProps: generalProps
            }));
            setTimeout(function () { return dispatch(getLongReadPosts(userid, lgid, sign)); }, 1000);
            //  в целом не зависит от запроса, можно не дожидаться
            // setIsSaveButtonPushed(true);
            toggleMobileEditor && toggleMobileEditor(false);
            toggleSubmenu && toggleSubmenu('');
        }
    };
    var clearEditor = function () {
        setTextValue("");
    };
    var handleCloseDrag = function (event) {
        if (event.type !== "touchmove")
            return;
        if (event.touches[0].clientY > 0) {
            menuRef.current.style.height = "calc(100% - ".concat(event.touches[0].clientY, "px)");
        }
    };
    var handleDragEnd = function (event) {
        menuRef.current.style.transition = "0.2s";
        if (window.innerHeight / 2.2 < event.changedTouches[0].clientY) {
            menuRef.current.style.height = "0px";
            setTimeout(function () { return closeEditor(); }, 200);
        }
        else {
            // menuRef.current.style.height = `calc(100% - 130px)`
            menuRef.current.style.height = "calc(100% - 40px)";
            setTimeout(function () { menuRef.current.style.transition = "0s"; }, 200);
        }
    };
    var closeEditor = function () {
        if (!isUpdate) {
            clearEditor();
            dispatch(setEditLongRead(false, undefined, lgid));
        }
        if (isUpdate) {
            dispatch(toggleLongReadPostUpdate(0, false, lgid));
        }
        toggleMobileEditor && toggleMobileEditor(false);
    };
    var handleClickOutside = function (event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            closeEditor();
        }
    };
    var handleSetTextValue = function (val) {
        setTextValue(val);
        onSetMobTextLength(val === null || val === void 0 ? void 0 : val.length);
    };
    useEffect(function () {
        if (mobileEditorAction === MobileEditorActions.add) {
            savePost();
        }
        if (mobileEditorAction === MobileEditorActions.close) {
            closeEditor();
        }
    }, [mobileEditorAction]);
    // useEffect(() => {
    //   document.addEventListener('click', handleClickOutside, true)
    //   return () => {
    //     document.removeEventListener('click', handleClickOutside, true)
    //   }
    // }, [])
    return (React.createElement(Backdrop, null,
        React.createElement(Wrap, { ref: menuRef, id: "longreadTextEditorMobile" },
            React.createElement(SelectorClose, { onTouchMove: handleCloseDrag, onTouchEnd: handleDragEnd }),
            React.createElement(Header, null,
                React.createElement(HeaderItem, null, t('editor.inputs.post')),
                React.createElement(HeaderItem, null,
                    textvalue.length,
                    "/2400")),
            React.createElement(AreaWrap, { bigTypeText: (post === null || post === void 0 ? void 0 : post.style) === 'colored' },
                React.createElement("textarea", { autoFocus: true, value: textvalue, onChange: function (e) { return handleSetTextValue(e.target.value); }, placeholder: t('editor.inputs.write'), maxLength: '2400', className: 'mobile-textarea' })))));
}
export default BottomTextEditor;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=texteditormobile.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { updateLongReadPost } from '../../../../actions/updateLongReadPost';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import { MEDIA_QUERY, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import { SelectorClose } from './selecter';
import { setEditLongRead } from '../../../../actions/setEditLongRead';
import useLocalization from '../../../../hooks/useLocalization';
import CloseIcon from '../../../icons/CloseIcon';
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import useCommonProps from "../../../../hooks/useCommonProps";
import { MobileEditorActions } from '../../../../constants/mobileEditorActions';
import { useGeneralProps } from '../../../../hooks/useGeneralProps';
var Backdrop = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: none;\n  z-index: 1000001;\n  @media (max-width: ", "px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: none;\n  z-index: 1000001;\n  @media (max-width: ", "px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n"])), MEDIA_QUERY_MOBILE);
var Wrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  background: #ffffff;\n  touch-action: none;\n  height: calc(100% - 40px);\n  border-radius: 8px 8px 0 0;\n"], ["\n  position: relative;\n  width: 100%;\n  background: #ffffff;\n  touch-action: none;\n  height: calc(100% - 40px);\n  border-radius: 8px 8px 0 0;\n"])));
var Header = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  //styleName: 320px/Small Text (Reg);\n  font-family: Inter;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #70706f;\n  background: #ffffff;\n  padding: 12px 10px;\n  padding-top: 6px;\n"], ["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  //styleName: 320px/Small Text (Reg);\n  font-family: Inter;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #70706f;\n  background: #ffffff;\n  padding: 12px 10px;\n  padding-top: 6px;\n"])));
var HeaderItem = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var AreaWrap = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 12px;\n  padding-left: 10px;\n  padding-right: 10px;\n\n  textarea,\n  input {\n    resize: none;\n    font-style: normal;\n    font-weight: ", ";;\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: -0.44px;\n    color: #151514;\n    border: none;\n    height: calc(100vh - 64px);\n    width: 100%;\n    outline: none;\n    padding-bottom: 80px;\n  }\n\n  > textarea {\n    overflow-y: auto !important;\n  }\n"], ["\n  margin-top: 12px;\n  padding-left: 10px;\n  padding-right: 10px;\n\n  textarea,\n  input {\n    resize: none;\n    font-style: normal;\n    font-weight: ", ";;\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: -0.44px;\n    color: #151514;\n    border: none;\n    height: calc(100vh - 64px);\n    width: 100%;\n    outline: none;\n    padding-bottom: 80px;\n  }\n\n  > textarea {\n    overflow-y: auto !important;\n  }\n"])), function (p) { return p.bigTypeText ? "700" : "400"; }, function (p) { return p.bigTypeText ? "22px" : "15px"; }, function (p) { return p.bigTypeText ? "28px" : "20px"; });
var Footer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  //todo: \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u0435\u0440\u0435\u043A\u0440\u044B\u0442\u0438\u0435 \u043A\u043D\u043E\u043F\u043A\u0438 \u043F\u0430\u0431\u043B\u0438\u0448\n  height: 100px;\n  border-radius: 8px 8px 0 0;\n  bottom: 0;\n  background: #ffffff;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding-left: 13px;\n  padding-right: 13px;\n  padding-top: 14px;\n  width: 100%;\n"], ["\n  position: absolute;\n  //todo: \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u0435\u0440\u0435\u043A\u0440\u044B\u0442\u0438\u0435 \u043A\u043D\u043E\u043F\u043A\u0438 \u043F\u0430\u0431\u043B\u0438\u0448\n  height: 100px;\n  border-radius: 8px 8px 0 0;\n  bottom: 0;\n  background: #ffffff;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding-left: 13px;\n  padding-right: 13px;\n  padding-top: 14px;\n  width: 100%;\n"])));
var FooterItem = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-family: 'Inter', sans-serif;\n  font-size: 17px;\n  line-height: 22px;\n  font-weight: 700;\n  color: #b1b4ae;\n"], ["\n  font-family: 'Inter', sans-serif;\n  font-size: 17px;\n  line-height: 22px;\n  font-weight: 700;\n  color: #b1b4ae;\n"])));
var SaveButton = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n  border: 1px solid #151514;\n  border-radius: 3px;\n  padding: 4px 16px;\n  color: #151514;\n"], ["\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 16px;\n  border: 1px solid #151514;\n  border-radius: 3px;\n  padding: 4px 16px;\n  color: #151514;\n"])));
function BottomTextEditor(props) {
    var toggleSubmenu = props.toggleSubmenu, submenu = props.submenu, lgid = props.lgid, isUpdate = props.isUpdate, post = props.post, lang = props.lang, mobileEditorAction = props.mobileEditorAction, toggleMobileEditor = props.toggleMobileEditor, onSetMobTextLength = props.onSetMobTextLength;
    var _a = useState(false), toggle = _a[0], setToggle = _a[1];
    var _b = useState(isUpdate ? post.text : ''), textvalue = _b[0], setTextValue = _b[1];
    var _c = useState(false), isSaveButtonPushed = _c[0], setIsSaveButtonPushed = _c[1];
    var dispatch = useDispatch();
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, lgid); });
    var blocks = currentStore.blocks;
    var userid = localStorage.getItem('userId');
    var t = useLocalization().t;
    var sign = useCommonProps().sign;
    var generalProps = useGeneralProps();
    var menuRef = useRef(null);
    useEffect(function () {
        document.body.style.overflowY = 'hidden';
        document.body.style.touchAction = 'none';
        return function () {
            document.body.style.overflowY = '';
            document.body.style.touchAction = 'auto';
        };
    }, [post]);
    useEffect(function () {
        var _a;
        onSetMobTextLength(((_a = post === null || post === void 0 ? void 0 : post.text) === null || _a === void 0 ? void 0 : _a.length) || 0);
    }, []);
    var savePost = function () {
        // if (isSaveButtonPushed) {
        //   return false;
        // }
        if (isUpdate) {
            var newPost = __assign({}, post);
            newPost.text = textvalue;
            setTimeout(function () { return dispatch(getLongReadPosts(userid, lgid, sign)); }, 1000);
            dispatch(updateLongReadPost('', newPost));
            dispatch(toggleLongReadPostUpdate(0, false, lgid));
            //  в целом не зависит от запроса, можно не дожидаться
            // toggleSubmenu("");
        }
        else {
            dispatch(addLongReadPost({
                id: userid,
                title: '',
                text: textvalue,
                color: 'white',
                imageid: '',
                lgid: lgid,
                isFL: false,
                imgCaption: '',
                style: 'normal',
                num: blocks.length,
                imageData: '',
                generalProps: generalProps
            }));
            setTimeout(function () { return dispatch(getLongReadPosts(userid, lgid, sign)); }, 1000);
            //  в целом не зависит от запроса, можно не дожидаться
            // setIsSaveButtonPushed(true);
            toggleMobileEditor && toggleMobileEditor(false);
            toggleSubmenu && toggleSubmenu('');
        }
    };
    var clearEditor = function () {
        setTextValue("");
    };
    var handleCloseDrag = function (event) {
        if (event.type !== "touchmove")
            return;
        if (event.touches[0].clientY > 0) {
            menuRef.current.style.height = "calc(100% - ".concat(event.touches[0].clientY, "px)");
        }
    };
    var handleDragEnd = function (event) {
        menuRef.current.style.transition = "0.2s";
        if (window.innerHeight / 2.2 < event.changedTouches[0].clientY) {
            menuRef.current.style.height = "0px";
            setTimeout(function () { return closeEditor(); }, 200);
        }
        else {
            // menuRef.current.style.height = `calc(100% - 130px)`
            menuRef.current.style.height = "calc(100% - 40px)";
            setTimeout(function () { menuRef.current.style.transition = "0s"; }, 200);
        }
    };
    var closeEditor = function () {
        if (!isUpdate) {
            clearEditor();
            dispatch(setEditLongRead(false, undefined, lgid));
        }
        if (isUpdate) {
            dispatch(toggleLongReadPostUpdate(0, false, lgid));
        }
        toggleMobileEditor && toggleMobileEditor(false);
    };
    var handleClickOutside = function (event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            closeEditor();
        }
    };
    var handleSetTextValue = function (val) {
        setTextValue(val);
        onSetMobTextLength(val === null || val === void 0 ? void 0 : val.length);
    };
    useEffect(function () {
        if (mobileEditorAction === MobileEditorActions.add) {
            savePost();
        }
        if (mobileEditorAction === MobileEditorActions.close) {
            closeEditor();
        }
    }, [mobileEditorAction]);
    // useEffect(() => {
    //   document.addEventListener('click', handleClickOutside, true)
    //   return () => {
    //     document.removeEventListener('click', handleClickOutside, true)
    //   }
    // }, [])
    return (React.createElement(Backdrop, null,
        React.createElement(Wrap, { ref: menuRef, id: "longreadTextEditorMobile" },
            React.createElement(SelectorClose, { onTouchMove: handleCloseDrag, onTouchEnd: handleDragEnd }),
            React.createElement(Header, null,
                React.createElement(HeaderItem, null, t('editor.inputs.post')),
                React.createElement(HeaderItem, null,
                    textvalue.length,
                    "/2400")),
            React.createElement(AreaWrap, { bigTypeText: (post === null || post === void 0 ? void 0 : post.style) === 'colored' },
                React.createElement("textarea", { autoFocus: true, value: textvalue, onChange: function (e) { return handleSetTextValue(e.target.value); }, placeholder: t('editor.inputs.write'), maxLength: '2400', className: 'mobile-textarea' })))));
}
export default BottomTextEditor;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=texteditormobile.js.map